var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyAutoAssign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40.0001,
    r: 40,
    fill: "#F4F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0013 35.0001V30.0001C34.4846 30.0001 30.0013 34.4835 30.0013 40.0001C30.0013 41.6835 30.418 43.2835 31.168 44.6668L28.7346 47.1001C27.4346 45.0501 26.668 42.6168 26.668 40.0001C26.668 32.6335 32.6346 26.6668 40.0013 26.6668V21.6668L46.668 28.3335L40.0013 35.0001ZM48.8346 35.3335L51.268 32.9001C52.568 34.9501 53.3346 37.3835 53.3346 40.0001C53.3346 47.3668 47.368 53.3335 40.0013 53.3335V58.3335L33.3346 51.6668L40.0013 45.0001V50.0001C45.518 50.0001 50.0013 45.5168 50.0013 40.0001C50.0013 38.3168 49.568 36.7335 48.8346 35.3335Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyAutoAssign);
export default __webpack_public_path__ + "static/media/empty-auto-assign.c585b828ca4c5cba063ca56835e24974.svg";
export { ForwardRef as ReactComponent };